import React from "react";
import { PuffLoader } from "react-spinners";
import ModalCloseButton from "../common/ModalCloseButton";
import ModalTitle from "../common/ModalTitle";
import ModalDecorations from "./ModalDecorations";
import FieldRenderer from "./FieldRenderer";
import ModalButton from "../common/ModalButton";
import AuthRedirectText from "./AuthRedirectText";
import { ELEMENT_IDS } from "constants/constants";
import ModalDialog from "../common/ModalDialog";
import ModalContent from "../common/ModalContent";
import ModalHeader from "../common/ModalHeader";
import ModalFooter from "../common/ModalFooter";
import ModalBody from "../common/ModalBody";
import SignupLogo from "./SignupLogo";

export default function LoginForm({
  setIsOpen,
  role,
  inputFields,
  modalType,
  handleInputChange,
  handleLoginPress,
  loading,
  showPassword,
  setShowPassword,
  setSignUpOptions,
  setErrors,
  handleCloseModal,
  setForgotPassOptions,
  setLogInOptions,
  setModalType,
}) {
  // console.log({ "inputFields.logInFields": inputFields.logInFields, modalType });

  const logInModalCloseId = "logIn-modal-close";
  const isTyped = inputFields.logInFields.every(field => field.value.trim() !== "");

  return (
    <ModalDialog>
      <ModalContent
        className={` sm:tw-p-[20px] 
            tw-min-h-[100dvh]
            [@supports(not(height:100dvh))]:tw-min-h-[100vh]
        )} `}
        isUseKeyboardAwareBar={true}
      >

        {role === 1 ? (
          <SignupLogo variant="creator" showDesktop extraClass="creator-signup-inside-logo" />
        ) : (
          <SignupLogo variant="brand" showDesktop extraClass="brand-signup-inside-logo" />
        )}
        <ModalHeader className="sm:tw-pt-[50px] tw-border-none">
          <ModalTitle text={role === 1 ? "Creator login" : "Brand login"} />

          <ModalCloseButton
            id={logInModalCloseId}
            onClose={() => {
              setSignUpOptions(false);
              setErrors([]);
              handleCloseModal();
            }}
          />
        </ModalHeader>

        <ModalBody>
          {/* Decorations */}
          <ModalDecorations />

          {/* Inputs */}
          <div className="login-feilds-width tw-w-full">
            {inputFields.logInFields.map((field, index) => (
              // <div className="mb-2 position-relative" key={`login-${field.key}-${index}`}>
              <FieldRenderer
                key={`login-${field.key}-${index}`}
                className="tw-mb-2 md:tw-mb-0 tw-relative"
                field={field}
                handleInputChange={handleInputChange}
                handlePress={handleLoginPress} // login dùng chung
                modalType={modalType}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
                // showConfirmPassword={showConfirmPassword}
                // setShowConfirmPassword={setShowConfirmPassword}
                withLabel={true} // để render label + required giống code cũ
              />
              // </div>
            ))}

            {/* Forgot password link */}
            <div className="tw-flex">
              <span className="d-flex justify-content-center pt-4 pointer-cursor
              tw-ml-auto sm:tw-m-auto
              ">
                <span
                  onClick={() => {
                    setLogInOptions(false);
                    setSignUpOptions(false);
                    setForgotPassOptions(true);
                    setModalType("forgotPassFields");
                  }}
                  className="infoText
                  tw-font-[450] 
                  tw-text-[14px] sm:tw-text-[16px]
                  tw-leading-[140%] 
                  tw-text-[#549A9C] sm:tw-text-[#282828]
                  "
                >
                  Forgot Password?
                </span>
              </span>
            </div>
          </div>
        </ModalBody>

        <ModalFooter
          isUseKeyboardAwareBar
          className={
            // Mặc định sticky ở đáy khung nhìn của modal
            "tw-z-50 tw-mt-auto sm:tw-mt-0 tw-sticky sm:tw-relative tw-bottom-[15px] " +
            // Chừa safe-area dưới (home indicator)
            "tw-pb-[calc(env(safe-area-inset-bottom))] " +
            // Khi hook bật is-focusin → và đội lên bàn phím
            // (Tailwind arbitrary value cho calc)
            "[&.is-focusin]:tw-relative [&.is-focusin]:tw-mt-0"
          }
        >
          <AuthRedirectText
            question="Don’t have an account?"
            actionText="Sign up"
            onAction={() => {
              console.log("Sign up");
              document.getElementById(logInModalCloseId)?.click();
              document.getElementById(ELEMENT_IDS.BTN_SIGN_UP_FROM_LP)?.click();
              //
              setSignUpOptions(true);
              setIsOpen(false);
              setErrors([]);
              handleCloseModal();
            }}
          />


          <ModalButton
            className="sm:tw-m-auto"
            label="Login"
            onClick={() => handleLoginPress(modalType)}
            loading={loading}
            disabled={!isTyped}
          />
        </ModalFooter>
      </ModalContent>
    </ModalDialog>
  );
}
